import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppServerAPI, DateUtilsService, SelectFieldOption, TranslationService } from '@sdbn/common';
import { AreaGateLogRepresentation, AreaGateLogSelection } from '../area-gate-log.model';
import { AppClientConfiguration } from '@sdbn/common';

@Component({
  selector: 'app-area-gate-log-administration',
  templateUrl: './area-gate-log-administration.component.html',
  styleUrls: ['./area-gate-log-administration.component.scss']
})
export class AreaGateLogAdministrationComponent implements OnInit {

  dataSource = new MatTableDataSource(new Array<AreaGateLogRepresentation>());

  columnsToDisplay = ['date', 'gate', 'direction', 'event', 'filler'];

  selected: AreaGateLogRepresentation;

  selection = new AreaGateLogSelection();

  types: Array<SelectFieldOption>;

  fromGroup = new FormGroup({
    dateFrom: new FormControl(null, []),
    dateUntil: new FormControl(null, []),
    type: new FormControl(null, [])
  });

  constructor(
    public translationService: TranslationService,
    private dateUtils: DateUtilsService,
    private appServerAPI: AppServerAPI,
    private appClientConfiguration: AppClientConfiguration
  ) { }

  ngOnInit(): void {

    let types = new Array<SelectFieldOption>();
    types.push(new SelectFieldOption({ labelDictionaryKey: 'tmc-common.reports.ui.enum.area-gate-log-event.numberplate_recognition_failed', value: 'numberplate_recognition_failed' }));
    this.types = types;

    this.selection.dateFrom = this.dateUtils.convertDateToDatePartTimestamp(new Date());
    this.selection.dateUntil = this.dateUtils.convertDateToDatePartTimestamp(new Date());
    this.selection.type = 'numberplate_recognition_failed';

    this.fromGroup.patchValue({
      dateFrom: this.dateUtils.parseDateFromDatePartTimestamp(this.selection.dateFrom),
      dateUntil: this.dateUtils.parseDateFromDatePartTimestamp(this.selection.dateUntil),
      type: this.selection.type,
    });

    this.fromGroup.valueChanges.subscribe(value => {
      this.selection.dateFrom = this.dateUtils.convertDateToDatePartTimestamp(value.dateFrom);
      this.selection.dateUntil = this.dateUtils.convertDateToDatePartTimestamp(value.dateUntil);
      this.selection.type = value.type;
      console.log('values changed', value, this.selection);
    });

    this.loadLogEntries();

  }

  private loadLogEntries() {
    this.appServerAPI.execute<AreaGateLogRepresentation[]>('/tmc-common/areaGateLog/findLogs',
      this.selection).subscribe(response => {

        let rows = new Array<AreaGateLogRepresentation>();
        for (const entry of response) {
          rows.push(new AreaGateLogRepresentation(entry));
        }
        this.dataSource = new MatTableDataSource(rows);


      }, error => {
      });
  }

  sortChanged($event: Sort) {
  }

  onClickRow(selected: AreaGateLogRepresentation) {
    this.selected = selected;
  }

  public refresh() {
    this.loadLogEntries();
  }

}
